import React from "react";

type Props = {
  progressPercentage: number;
  size: number;
};

const ProgressCircle = ({ progressPercentage, size }: Props) => {
  const strokeWidth = size * 0.1; // 10% of the size for strokeWidth
  const radius = size / 2 - strokeWidth;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progressPercentage / 100) * circumference;

  return (
    <svg width={size} height={size}>
      {/* Background circle */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill='none'
        stroke='#F3EBFF'
        strokeWidth={strokeWidth}
      />
      {/* Fill circle */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill='none'
        stroke='#8B33FF'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeDasharray={`${circumference} ${circumference}`}
        strokeDashoffset={offset}
        // Rotate the circle to start from the top
        transform={`rotate(-90, ${size / 2}, ${size / 2})`}
      />
    </svg>
  );
};

export default ProgressCircle;
